import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import PageHeader from '../components/PageHeader.jsx'
import PartForm from '../components/PartForm.jsx'
import { useInventory } from '../components/InventoryProvider.jsx'
import { useToast } from '../components/ToastProvider.jsx'
import { isMergedPart } from '../utils/stock'

export default function PartEditPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { getPart, loadPart, updatePart } = useInventory()
  const { show } = useToast()
  const cached = getPart(id)
  const [fetched, setFetched] = useState(null)
  const [loadError, setLoadError] = useState('')
  const part = cached || fetched

  useEffect(() => {
    let cancelled = false
    if (cached) {
      setLoadError('')
      return undefined
    }
    loadPart(id)
      .then((loaded) => {
        if (cancelled) return
        if (loaded) setFetched(loaded)
        else setLoadError('부품을 찾을 수 없습니다.')
      })
      .catch((err) => {
        if (!cancelled) setLoadError(err.message || '데이터를 불러오는 중 오류가 발생했습니다.')
      })
    return () => {
      cancelled = true
    }
  }, [id, cached, loadPart])

  if (!part) {
    return (
      <div className="page">
        <PageHeader title={loadError || '부품을 찾는 중...'} />
        <Link to="/inventory" className="btn btn--primary btn--touch">
          재고 목록으로
        </Link>
      </div>
    )
  }

  if (isMergedPart(part)) {
    return (
      <div className="page">
        <PageHeader title="정보 수정" description={`${part.partCode} · ${part.model || part.name}`} />
        <p className="merge-banner">
          이 품목은 <Link to={`/inventory/${part.mergedIntoPartId}`}>{part.mergedIntoPartCode || '대표 품목'}</Link>
          로 병합되어 수정할 수 없습니다.
        </p>
        <Link to={`/inventory/${part.id}`} className="btn btn--primary btn--touch">
          상세로
        </Link>
      </div>
    )
  }

  async function handleSubmit(form) {
    await updatePart(part.id, form)
    show('부품 정보를 수정했습니다.')
    navigate(`/inventory/${part.id}`)
  }

  return (
    <div className="page">
      <PageHeader title="정보 수정" description={`${part.partCode} · ${part.model || part.name}`} />
      <PartForm
        initialValue={part}
        submitLabel="저장"
        onSubmit={handleSubmit}
        onCancel={() => navigate(`/inventory/${part.id}`)}
      />
    </div>
  )
}
